/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { useContext } from "react";
import { EditorContext } from "../../Context/EditorContext";

const CodeOutput = () => {
  const { url, activeView, outputRef } = useContext(EditorContext);

  return (
    <iframe
      ref={outputRef}
      style={{
        width: activeView === "Full Page View" ? "100%" : "calc(100% - 500px)",
      }}
      css={styles}
      src={url}
      frameBorder="0"
    ></iframe>
  );
};

const styles = css`
  margin: 0 auto;
  height: calc(100vh - 88px);
  overflow: hidden;
`;

export default CodeOutput;
